export default {
    name: "PlatformCustomerManage",
    data() {
        return {
            searchForm: {
                portName: '',
                pageNum: 1,
                pageSize: 50
            },
            tableData: [],
            selected: [],
            total: 0
        }
    },
    created(){
        let conditionParam = this.$routerUtil.getParam();
        if(conditionParam && conditionParam.searchForm){
            conditionParam = conditionParam.searchForm;
        }
        console.log(conditionParam);
        this.$routerUtil.clearParam();
        if(conditionParam){
            this.$nextTick(() => {
                this.searchForm = conditionParam;
                this.doSearch();
            });
        }
    },
    methods: {
        handleSizeChange(val){
            this.searchForm.pageSize = val;
            this.doSearch();
        },
        handleCurrentChange(val){
            this.searchForm.pageNum = val;
            this.doSearch();
        },
        handleSelectionChange(val) {
            this.selected = val;
        },
        rowClick(row){
            this.$refs.table.toggleRowSelection(row);
        },
        doSearch() {
            const param = this.$paramUtil.clearEmpty(this.searchForm);
            // param.systemCode = JSON.parse(sessionStorage.getItem('currentSystem')).code;
            this.$axios.get('/api/cost/selectcostbyparam/', {params: param}).then(response => {
                this.tableData = response.data.resultData.rows;
                this.total = response.data.resultData.total;
            }).catch(e => {
                console.log(e);
                this.$message({
                    message: this.$t('common.message.operateFail'),
                    type: 'error',
                    center: true
                });
            });
        },
        doAdd(){
            const conditionData = new Object();
            conditionData.searchForm = this.searchForm;
            this.$routerUtil.setParam(conditionData);
            this.$router.push('addCost');
        },
        doEdit(){
            const conditionData = new Object();
            conditionData.searchForm = this.searchForm;
            conditionData.row = this.getSelectedRow();
            if (conditionData && conditionData.row) {
                this.$routerUtil.setParam(conditionData);
                this.$router.push('editCost');
            }
        },
        doDelete() {
            const param = {};
            param.ids = this.selected;
            const conditionData = new Object();
            conditionData.searchForm = this.searchForm;
            conditionData.row = this.getSelectedRow();
            if (conditionData && conditionData.row) {
                this.$confirm(this.$t('p_costManage.message.confirmDelete'), this.$t('p_costManage.message.sysPrompt'), {
                    confirmButtonText: this.$t('p_costManage.message.confirm'),
                    cancelButtonText: this.$t('p_costManage.message.cancel'),
                    cancelButtonClass: 'btn-custom-cancel',
                    type: 'warning'
                }).then(() => {
                    this.$axios.post('/api/cost/deletecost', param).then(response => {
                        let type = 'error';
                        if (response.data.status === '1') {
                            type = 'success';
                            this.doSearch();
                        }
                        this.$message({
                            message: this.$t(response.data.message),
                            type: type,
                            center: true
                        });
                    }).catch(e => {
                        console.log(e);
                        this.$message({
                            message: this.$t('common.message.operateFail'),
                            type: 'error',
                            center: true
                        });
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('p_costManage.message.cancelDel'),
                        center: true
                    });
                });
            }

        },
        getSelectedRow(){
            if (this.selected.length > 1) {
                this.$message({
                    message: this.$t('common.message.onlyOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            if (this.selected.length < 1) {
                this.$message({
                    message: this.$t('common.message.atLastOneRow'),
                    type: 'warning',
                    center: true
                });
                return null
            }
            return this.selected[0];
        },
        doReset(){
            this.searchForm.portName = '';
        }
    }
}
